import React from 'react';
import { Button } from '@/components/ui/button';
import { X, Download, ZoomIn, ZoomOut, RotateCw } from 'lucide-react';

interface PDFViewerProps {
  isOpen: boolean;
  pdfUrl: string | null;
  onClose: () => void;
  title?: string;
}

export default function PDFViewer({ isOpen, pdfUrl, onClose, title = "Rapport généré" }: PDFViewerProps) {
  if (!isOpen || !pdfUrl) return null;

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = `${title.replace(/\s+/g, '_')}_${new Date().toISOString().slice(0, 10)}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="fixed inset-0 bg-white/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white backdrop-blur-xl border border-gray-300 rounded-2xl w-full max-w-6xl h-full max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-300">
          <div className="flex items-center space-x-3">
            <div className="w-2 h-2 bg-red-500 rounded-full"></div>
            <div className="w-2 h-2 bg-yellow-500 rounded-full"></div>
            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
            <span className="text-black font-medium ml-4">{title}</span>
          </div>
          
          <div className="flex items-center space-x-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={handleDownload}
              className="text-black hover:bg-white"
            >
              <Download size={16} className="mr-1" />
              Télécharger
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={onClose}
              className="text-black hover:bg-white"
            >
              <X size={16} />
            </Button>
          </div>
        </div>

        {/* PDF Content */}
        <div className="flex-1 p-4">
          <iframe
            src={pdfUrl}
            className="w-full h-full rounded-lg border border-gray-300"
            title={title}
            style={{ minHeight: '600px' }}
          />
        </div>

        {/* Footer with controls */}
        <div className="p-4 border-t border-gray-300 flex items-center justify-center space-x-2">
          <Button variant="ghost" size="sm" className="text-black hover:bg-white">
            <ZoomOut size={14} />
          </Button>
          <span className="text-black text-sm px-3">100%</span>
          <Button variant="ghost" size="sm" className="text-black hover:bg-white">
            <ZoomIn size={14} />
          </Button>
          <div className="w-px h-4 bg-white/20 mx-2"></div>
          <Button variant="ghost" size="sm" className="text-black hover:bg-white">
            <RotateCw size={14} />
          </Button>
        </div>
      </div>
    </div>
  );
}
